import {VUE_VERSION} from "@/constants/appConstants";

export const initGlobalPropertiesService  = (app) => {
    app.provide('storeFourBaseUrl', import.meta.env.VITE_APP_STORE_IMAGE_URL);
    app.provide('studentBaseUrl', import.meta.env.VITE_APP_STUDENT_MAIN_URL);
    app.provide('newStudentBaseUrl', import.meta.env.VITE_APP_SECONDARY_URL)
    app.config.globalProperties.$baseUrl = import.meta.env.VITE_APP_MAIN_URL + "/api/v1";
    app.config.globalProperties.$baseImgUrlPanel = import.meta.env.VITE_APP_MAIN_URL+ "/uploads/images"
    app.config.globalProperties.$studentBaseUrl = import.meta.env.VITE_APP_STUDENT_MAIN_URL
    app.config.globalProperties.$baseMenuImageUrl= import.meta.env.VITE_APP_MENU_IMAGE_URL;
    app.config.globalProperties.$login1402Url = import.meta.env.VITE_APP_STUDENT_MAIN_URL + "/redirectAfterLogin/dashboard";
    app.config.globalProperties.$nxBaseUrl = import.meta.env.VITE_APP_STUDENT_MAIN_URL
    app.config.globalProperties.$siteUrl = import.meta.env.VITE_APP_MAIN_URL;
    app.config.globalProperties.$storeFourBaseUrl = import.meta.env.VITE_APP_STORE_IMAGE_URL;
    app.config.globalProperties.app_version = VUE_VERSION;
// app.config.globalProperties.$baseImgUrl = "https://panel1402.classino.com";
//  app.config.globalProperties.$baseImgUrl = "https://staging.classino.com/";
// app.config.globalProperties.$baseImgUrl = "http://127.0.0.1:8000";
// app.config.globalProperties.$baseUrl = import.meta.env.VITE_APP_MAIN_URL + "/api/v1";
// app.config.globalProperties.$baseUrl = "https://panel1402.classino.com/api/v1";
//  app.config.globalProperties.$baseUrl = "https://clone.classino.com/api/v1";
// app.config.globalProperties.$baseUrl = "http://127.0.0.1:8000/api/v1";
// app.config.globalProperties.$baseImgUrl = import.meta.env.VITE_APP_MAIN_URL;

}
